import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { NgxGpAutocompleteDirective, NgxGpAutocompleteModule } from '@angular-magic/ngx-gp-autocomplete';
import { Store, createSelector } from '@ngrx/store';
import { animationFrameScheduler, filter, observeOn, take, tap } from 'rxjs';

import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { overviewLocationsFeature } from 'src/app/job/job-overview/overview-locations/overview-locations.feature';
import { GoogleHelperService } from 'src/app/services/google-helper.service';

import { OverviewLocationsComponent } from '../../job/job-overview/overview-locations/overview-locations.component';
import { newOpportunityFeature } from '../new-opportunity.feature';

import { NewOpportunityLocationsActions } from './new-opportunity-locations.actions';

@Component({
  selector: 'app-new-opportunity-locations',
  standalone: true,
  imports: [
    FreyaCommonModule,
    NgxGpAutocompleteModule,
    OverviewLocationsComponent,
  ],
  templateUrl: './new-opportunity-locations.component.html',
  styleUrls: ['./new-opportunity-locations.component.scss'],
})
export class NewOpportunityLocationsComponent implements AfterViewInit {

  @ViewChild(NgxGpAutocompleteDirective) addressAutocomplete: NgxGpAutocompleteDirective;

  public actions = NewOpportunityLocationsActions;

  public viewModel$ = this.store.select(createSelector({
    minimalView: newOpportunityFeature.selectLocationsStepMinimalView,
    address: createSelector(
      overviewLocationsFeature.selectLocationEditors,
      (editors) => editors.start?.address || '',
    ),
    locationInvalid: createSelector(
      overviewLocationsFeature.selectLocationEditors,
      (editors) => !editors.start?.selectedLocation,
    ),
  }));

  constructor(
    public store: Store,
    public googleHelper: GoogleHelperService,
  ) {}

  ngAfterViewInit(): void {
    this.store.select(newOpportunityFeature.selectLocationsStepMinimalView).pipe(
      take(1),
      filter(Boolean),
      observeOn(animationFrameScheduler),
      tap(() => {

        const autocomplete = this.addressAutocomplete?.el?.nativeElement;

        if (!autocomplete) return;

        autocomplete.focus();
      }),
    ).subscribe();
  }
}
